<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/olSzzd/tc-custom/9781614233046.jpg?1708776422412" alt="This image is the cover for the book Boston Mob Guide"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Boston Mob Guide
      </h1>
      <p class="bookDescription body article font2">
        <p><b>Explore the backrooms and seedy hangouts throughout the real story of Boston’s gangster past in this true crime history guide.</b></p> The capture of notorious mobster James “Whitey” Bulger closed an infamous chapter in Boston history, yet the city’s criminal underworld has a long and bloody rap sheet that stretches back to the beginning of the twentieth century. Journalists Ford and Schorow reveal the underbelly of Boston through profiles of ruthless gangsters like Charles “King” Solomon, the Angiulo brothers, Joseph “The Animal” Barboza, Stephen “The Rifleman” Flemmi and many more who carried out deadly hits and lucrative heists.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Beverly Ford, Stephanie Schorow
      </h2>
      
      <p class="authorDescription body article">Beverly Ford is a Boston-based journalist and author who has spent more than twenty years as a reporter and freelance writer for the Boston Herald, the New York Daily News, the London Times, the London Mirror, Access Magazine, Bloomberg News and other publications. She has written about mob murders and court trials involving several people profiled in this book. She currently works as a freelance investigative journalist for the New England Center for Investigative Journalism. She has ghostwritten two books, including a 1991 book on the Kennedy family, and also authored a book on domestic violence in 2001 for Information. She was among several reporters awarded the 1991 Associated Press Spot News Award for team coverage of a train accident and received awards in 1991 and 1995 for juvenile justice reporting from Parents of Murdered Children. She was also a guest panelist at a 2009 Neiman Foundation series at Harvard University and has lectured on crime and breaking news coverage at Boston-area colleges and universities. Stephanie Schorow is a Boston-based freelance writer, author, teacher and artist. She is the author of The Crime of the Century: How the Brink's Robbers Stole Millions and the Hearts of Boston; East of Boston: Notes from the Harbor Islands (The History Press, 2008); Boston on Fire: A History of Fires and Firefighting in Boston; and The Cocoanut Grove Fire. She was the editor of Boston's Fire Trail: A Walk Through the City's Fire and Firefighting History (The History Press, 2007). She has spent thirty years working for various news organizations, including the Boston Herald, the TAB chain, the Stamford Advocate and the Associated Press. She currently works as a freelancer for the Boston Globe and teaches writing at the Cambridge Center for Adult Education. She is working on her next book, tentatively titled Drinking Boston: A History of the City and Its Spirits.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The History Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7b3fe714